import {OAuthDataProps} from "../../context/type";

export const formatDateToLocale = (date: string, userData: OAuthDataProps) => {
    const jwtData =  userData.getJwtData();
    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }
    const newDate = new Date(date);
    const localeDate = newDate.toLocaleDateString(`${jwtData.locale.replace("_","-")}`, options) ?? "";

    return `${localeDate}`;
}

export const formatDateToLocaleWithTime = (date: string, userData: OAuthDataProps) => {
    const jwtData =  userData.getJwtData();
    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    }
    const newDate = new Date(date);
    const localeDate = newDate.toLocaleDateString(`${jwtData.locale.replace("_","-")}`, options) ?? "";

    return `${localeDate}`;
}

export const checkIfTokenExpired = (oauthData: OAuthDataProps, isTokenExpired: boolean) => {
    const jwtData = oauthData.getJwtData();
    if (null === oauthData.doRefreshToken || undefined === oauthData.doRefreshToken) return false;
    if (isTokenExpired || (jwtData?.exp * 1000 < Date.now().valueOf())) {
        oauthData.doRefreshToken();
        setTimeout( () => {
            window.location.reload();
        }, 2000)
        return true;
    }
}

export const base64toBlob = (data: string, mimeType: string) => {
    const base64WithoutPrefix = data && data.split(':')[1]?.split(',')[1];
    const bytes = window.atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
        out[length] = bytes.charCodeAt(length);//get the character code of each symbol from decoded base64 file and assign to out variable
    }
    return new Blob([out], { type: mimeType });
};